module.exports = __webpack_public_path__ + "img/7-black.8a1a3d15.png";